import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import * as React from "react"
import { checkSection } from "../helper-functions"
import { Box, HeroHeading, Section } from "./ui"

export default function Hero(props) {
  return (
    <Section background={checkSection(props.index)}>
      <Box style={{ display: "grid" }}>
        {props.image && (
          <GatsbyImage
            alt={props.image.alt}
            image={getImage(
              props.image.localFile.childImageSharp.gatsbyImageData
            )}
            style={{
              gridArea: "1/1",
              maxHeight: "600px",
              width: "100%",
            }}
            layout="fullWidth"
          />
        )}
        {props.h1 && (
          <Box
            style={{
              gridArea: "1/1",
              position: "relative",
              placeItems: "center",
              display: "grid",
            }}
          >
            <Box
              style={{
                background: "rgba(0,0,0,0.6)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "1rem",
              }}
            >
              <HeroHeading
                as="h1"
                center
                variant={props.textColor ? "light" : "dark"}
              >
                {props.h1}
              </HeroHeading>
            </Box>
          </Box>
        )}
      </Box>
    </Section>
  )
}

export const query = graphql`
  fragment HomepageHeroContent on HomepageHero {
    id
    h1: heading
    textColor
    image {
      id
      ... on ContentfulAsset {
        id
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      alt
    }
  }
`
